export const SherlockOrgTaskLabelsTypesIds = {
  EddTasksId: '66e92fef78579badecfc4202',
  SilentVerificationTasksId: '6747980de1a2c38349c74dd3',
  FraudReferralTasksId: '69ddfa710d353286afe42c37',
  // TODO: replace with real ATO automation org-task label id after creating it in Mongo
  AtoAutomationTasksId: '6a590814056a34b0f2d23653'
};
